export default [
  {
    path: '/relatorio-atendimentos',
    component: () => import('@/pages/AtendimentosNoMes/Index.vue'),
  },
  {
    path: '/relatorio-atendimentos/profissional',
    component: () => import('@/pages/AtendimentosNoMes/Profissional.vue'),
  },
]
